<template>
  <div class="clearfix_" id="dragonBoatFestival">
      <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='banner'">
        <div id="banner">
            <div @click="goto(val)" v-for="(val,idx) in item.content" :key="idx" class="banner_bg_box"><img class="banner_bg" :src="val.pic?val.pic:'http://img.source.9188cn.com/banner.png'"></div>
        </div>
      </div>
    
    <div id="content_">
        <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='goods_1'||item.parentName=='goods_1_copy1'||item.parentName=='goods_1_copy2'">
            <div id="goods_1" class="goods_1">
                <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0">
                    <div class="goods_title_box">
                        <img class="goods_1_goods_bg" src="http://img.source.9188cn.com/bg3.png">
                        <div class="goods_1_title goods_title">{{item.title}}</div>
                        </div>
                        <div class="goods_1_goods">
                        <dl @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="clearfix_">
                            <dt class="fl"><img :src="val.pic?val.pic:noImg"></dt>
                            <dd class="fl">
                            <p class="goods_1_txt1">{{val.name}}</p>
                            <p class="goods_1_txt2">{{val.goodsSellPoint}}</p>
                            <p class="goods_1_txt3 clearfix_"><span class="fl">RMB：</span><span class="fl">{{val.price}}</span></p>
                            <p class="goods_1_txt4 clearfix_"><span class="fl">立即购买</span></p>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
        <div v-for="(item,index) in allData" :key="index" v-if  ="item.parentName=='goods_4'||item.parentName=='goods_4_copy1'||item.parentName=='goods_4_copy2'">
            <div id="goods_4" class="goods_1">
                <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0">
                    <div class="goods_title_box">
                    <img class="goods_1_goods_bg" src="http://img.source.9188cn.com/bg3.png">
                    <div class="goods_1_title goods_title">{{item.title}}</div>
                </div>
                <div class="goods_1_goods">
                    <dl @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="clearfix_">
                        <dd style="margin-right:110px;" class="fl">
                            <p class="goods_1_txt1">{{val.name}}</p>
                            <p class="goods_1_txt2">{{val.goodsSellPoint}}</p>
                            <p class="goods_1_txt3 clearfix_"><span class="fl">RMB：</span><span class="fl">{{val.price}}</span></p>
                            <p class="goods_1_txt4 clearfix_"><span class="fl">立即购买</span></p>
                        </dd>
                        <dt style="margin-right: 0;" class="fl"><img :src="val.pic?val.pic:noImg"></dt>
                    </dl>
                </div>
                </div>
            </div>
        </div>
        <div v-for="(item,index) in allData" :key="index" v-if  ="item.parentName=='goods_2'||item.parentName=='goods_2_copy1'||item.parentName=='goods_2_copy2'">
            <div id="goods_2" class="goods_2">
				<div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0">
                    <div class="goods_2_title_box">
					<img class="goods_2_title_bg" src="http://img.source.9188cn.com/title.png">
					<div class="goods_2_title goods_title">{{item.title}}</div>
				</div>
				<div class="goods_2_goods clearfix_">
					<div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="dl_ fl">
						<div class="dt_"><img :src="val.pic?val.pic:noImg"></div>
						<div class="dd_ clearfix_">
							<p>{{val.name}}</p>
							<p>{{val.goodsSellPoint}}</p>
							<p class="clearfix_"><span>{{val.price}}</span><span>立即购买</span></p>
						</div>
					</div>
				</div>
                </div>
			</div>
        </div>
		<div v-for="(item,index) in allData" :key="index" v-if  ="item.parentName=='goods_3'||item.parentName=='goods_3_copy1'||item.parentName=='goods_3_copy2'">
            <div id="goods_3" class="goods_3">
				<div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0">
                    <div class="goods_2_title_box">
					<img class="goods_2_title_bg" src="http://img.source.9188cn.com/title.png">
					<div class="goods_2_title goods_title">{{item.title}}</div>
				</div>
				<div class="goods_3_goods clearfix_">
					<dl @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="fl">
						<dt><img :src="val.pic?val.pic:noImg"></dt>
						<dd>
							<p>{{val.name}}</p>
							<p>{{val.goodsSellPoint}}</p>
							<p><span>{{val.price}}</span><span>立即购买</span></p>
						</dd>
					</dl>
				</div>
                </div>
			</div>
        </div>
			
    </div>
</div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      allData:[],
      noImg:require("@/assets/img/aa.png")
    }
  },
  mounted:function(){
    this.getProject()
  },
  methods:{
		gotoGoodsDetail:function(obj){
			var t_=this
			var href=t_.$router.resolve({name:'goodsdetails',query:{goodsId:obj.id,isSupplyChainGoods:2,supplyChainTenantId:obj.supplyChainTenantId}})
			window.open(href.href,'_blank')
		},
		goto:function(obj){
			var t_ = this
			if( obj.status==1 ){
                if(obj.atriceId=='')return
				var href=this.$router.resolve({
					name:'articleList',
					query:{
						id:obj.atriceId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==2){
				var d = obj.categoryId
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						id: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==3){
				var d = obj.search
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						txt: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==5){
				window.open(obj.link)
			}else if(obj.status==6){
				var href=t_.$router.resolve({
					name:'goodsdetails',
					query:{
						goodsId:obj.goodsId,
						isSupplyChainGoods:2,
						supplyChainTenantId:obj.supplyChainTenantId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==9){
				if(obj.module==1){
					var href=this.$router.resolve({name:'teamGoods'});
					window.open(href.href,'_blank')
				}else if(obj.module==3){
					var href=this.$router.resolve({name:'couponList'});
					window.open(href.href,'_blank')
				}else if(obj.module==5){
					var href=this.$router.resolve({name:'activityList'});
					window.open(href.href,'_blank')
				}else if(obj.module==6){
					var href=this.$router.resolve({name:'scoreChange'});
					window.open(href.href,'_blank')
				}
			}
		},
    getProject:function(){
      var t_=this
      let data = Qs.stringify({
        channel:2,
        id:this.$route.query.id,
        tamp:localStorage.tamp?localStorage.tamp:''
      });
      axios.post(`${ip}formWorkInterface/getProject`, data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
		    t_.allData=res.data.results
        }else{
          return this.$router.push({
            path: '/'
          });
        }
      }).catch(err =>{
      })
    }
  }
}
</script>
<style scoped>
#dragonBoatFestival{
    width: 100%;
    background: url('http://img.source.9188cn.com/bg.jpg') repeat-y 0 0;
}
.banner_bg_box img{
    width: 100%;
}
#banner {
    width: 100%;
    height: auto;
    position: relative;
    margin-bottom: 30px;
}
#banner .banner_bg{
    width: 100%;
}
#content_ .goods_1{
    width: 100%;
    position: relative;
}
.goods_1_goods_bg{
    width: 100%;
}
#content_ .goods_1 .goods_1_title{
    width: 784px;
    height: 85px;
    position: absolute;
    top: 55px;
    left: 571px;
    color: #fff;
    text-align: center;
    line-height: 85px;
    font-size: 42px;
}
.goods_1_goods{
    width: 900px;
    /*height: 350px;*/
    position: absolute;
    top: 180px;
    left: 480px;
}
.goods_1_goods dl:first-child{
    margin-bottom: 105px;
}
.goods_1_goods dt img{
    height: 350px;
    width: 350px;
}
.goods_1_goods dt{
    margin-right: 110px;
}
.goods_1_goods dd{
    width: 440px;
    height: 350px;
}
.goods_1_goods dd .goods_1_txt1{
    color: #0caa93;
    font-size: 30px;
    margin-bottom: 30px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.goods_1_goods dd .goods_1_txt2{
    color: #9e9e9e;
    font-size: 20px;
    border-top: 2px solid #9e9e9e;
    border-bottom: 2px solid #9e9e9e;
    height: 60px;
    margin: 0 auto;
    line-height: 60px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-bottom: 30px;
}
.goods_1_goods dd .goods_1_txt3{
    color: #307e33;
    margin-left: 15px;
}
.goods_1_goods dd .goods_1_txt3 span:first-child{
    font-size: 20px;
    margin-top: 40px;
}
.goods_1_goods dd .goods_1_txt3 span:nth-child(2){
    font-size: 40px;
    margin-top: 23px;
}
.goods_1_goods dd .goods_1_txt4 span{
    color: #fff;
    width: 135px;
    height: 40px;
    background: #397734;
    border-radius: 15px;
    text-align: center;
    line-height: 40px;
    font-size: 22px;
    margin-top: 25px;
    text-align: center;
    margin-left: 15px;
		cursor: pointer;
}
.goods_2{
    width: 1208px;
    margin: 0 auto;
    margin-top: 70px;
    position: relative;
}
.goods_2 .goods_2_title_box,.goods_3 .goods_2_title_box{
    width: 876px;
    height: 137px;
    margin: 0 auto;
    position: relative;
    margin-bottom: 50px;
}
.goods_2 .goods_2_title,.goods_3 .goods_2_title{
    width: 791px;
    height: 87px;
    position: absolute;
    top: 50px;
    left: 40px;
    color:#fff;
    font-size: 42px;
    line-height: 87px;
    text-align: center;
}
.goods_2 .goods_2_goods{
    width: 1208px;
}
.goods_2 .goods_2_goods .dl_{
    width: 520px;
    height: 640px;
    margin-right: 100px;
    margin-bottom: 60px;
    background: url('http://img.source.9188cn.com/bg2.png');
    padding: 17px;
}
.goods_2 .goods_2_goods .dl_:nth-child(2n){
    margin-right: 0;
}
.goods_2 .goods_2_goods .dl_ .dt_{
    width: 100%;
    height: 408px;
    border-radius: 40px 40px 0 0;
    margin-top: -1px;
    overflow: hidden;
    margin-top: 10px;
}
.goods_2 .goods_2_goods .dl_ .dt_ img{
    height: 400px;
    width: 400px;
    margin: 0 auto;
    display: inherit;
}
.goods_2 .goods_2_goods .dl_ .dd_{
    padding: 0 50px;
}
.goods_2 .goods_2_goods .dl_ .dd_ p:first-child{
    color: #727272;
    font-size: 26px;
    text-align: center;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-bottom: 15px;
    margin-top: 15px;
}
.goods_2 .goods_2_goods .dl_ .dd_ p:nth-child(2){
     color: #3d3d3d;
     font-size: 20px;
     text-align: center;
     overflow: hidden;
     text-overflow:ellipsis;
     white-space: nowrap;
     margin-bottom: 30px;
     border-top: 1px dashed #515151;
     border-bottom: 1px dashed #515151;
     height: 50px;
     line-height: 50px;
 }
.goods_2 .goods_2_goods .dl_ .dd_ p:last-child{
}
.goods_2 .goods_2_goods .dl_ .dd_ p:last-child span:first-child{
    color: #2d7e32;
    font-size: 40px;
    margin-right: 30px;
    /*display: inline-block;*/
    vertical-align: bottom;
    float:left;
    margin-left: 58px;
    line-height: 46px;
}
.goods_2 .goods_2_goods .dl_ .dd_ p:last-child span:last-child{
    color: #fff;
    width: 170px;
    height: 46px;
    background: #2d7e32;
    border-radius: 15px;
    text-align: center;
    line-height: 46px;
    font-size: 24px;
    float: left;
		cursor: pointer;
    /*display: inline-block;*/
}
.goods_3{
    width: 1448px;
    margin: 0 auto;
    position: relative;
    margin-top: 30px;
}
.goods_3 dl{
    width: 386px;
    height: 476px;
    background: url('http://img.source.9188cn.com/bg1.png');
    margin-right: 100px;
    margin-bottom: 50px;
    padding: 15px;
}
.goods_3 dl:nth-child(3n){
    margin-right: 0;
}
.goods_3 dl dt{
    margin-top: 10px;
    height: 309px;
    border-radius: 27px 27px 0 0;
    overflow: hidden;
}
.goods_3 dl dt img{
    height: 300px;
    width: 300px;
    margin: 0 auto;
    display: inherit;
}
.goods_3 dl dd{
    padding: 0 40px;
}
.goods_3 dl dd p:first-child{
    color: #666;
    font-size: 26px;
    text-align: center;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-bottom: 20px;
}
.goods_3 dl dd p:nth-child(2){
    color: #3e3e3e;
    font-size: 20px;
    text-align: center;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-bottom: 15px;
    border-top: 1px dashed #585858;
    border-bottom: 1px dashed #585858;
    line-height: 50px;
    height: 50px;
}
.goods_3 dl dd p:last-child{
    text-align: center;
}
.goods_3 dl dd p:last-child span:first-child{
    color: #2a712b;
    font-size: 36px;
    margin-right: 30px;
    display: inline-block;
    vertical-align:bottom;
}
.goods_3 dl dd p:last-child span:last-child{
    color: #fff;
    width: 130px;
    height: 40px;
    background: #2a712b;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    display: inline-block;
    border-radius: 15px;
		cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/dragonBoatFestival/dragonBoatFestival.vue